import clsx from 'clsx';

interface SlotCountBadgeProps {
  count: number;
  className?: string;
  size?: 'sm' | 'md';
  onTap?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export function SlotCountBadge({ count, className, size = 'sm', onTap }: SlotCountBadgeProps) {
  if (count <= 0) return null;

  return (
    <span
      data-slot-count-badge=""
      role={onTap ? 'button' : undefined}
      tabIndex={onTap ? 0 : undefined}
      onPointerDown={e => e.stopPropagation()}
      onPointerUp={e => e.stopPropagation()}
      onClick={
        onTap
          ? e => {
              e.stopPropagation();
              onTap(e);
            }
          : undefined
      }
      onKeyDown={
        onTap
          ? e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onTap(e as unknown as React.MouseEvent<HTMLSpanElement>);
              }
            }
          : undefined
      }
      className={clsx(
        'absolute z-[1] flex items-center justify-center rounded-full font-bold tabular-nums shadow-sm',
        'bg-white/92 text-emerald-900 dark:bg-gray-900/85 dark:text-emerald-100',
        onTap && 'cursor-pointer active:scale-95',
        size === 'sm' ? 'bottom-0.5 right-0.5 h-[15px] min-w-[15px] px-0.5 text-[9px]' : 'bottom-1 right-1 h-[18px] min-w-[18px] px-1 text-[10px]',
        className
      )}
    >
      {count}
    </span>
  );
}
